import AhoyTracker from 'shared/ahoy_tracker';

export default class LivestreamingScheduleDatePicker {
  constructor(options) {
    this.element = options.element;
    this.ahoy = new AhoyTracker(options.element);
  }

  init() {
    this.bindClickDateElement();
  }

  bindClickDateElement() {
    this.element.querySelector('.b-livestreaming-daily-schedule__date').addEventListener('click', () => {
      if (this.isDatePickerHidden()) {
        this.showDatePicker();
      } else {
        this.hideDatePicker();
      }
    });
  }

  isDatePickerHidden() {
    let datePickerElement = this.element.querySelector('.b-livestreaming-daily-schedule__date-picker');
    return datePickerElement.classList.contains('b-livestreaming-daily-schedule__date-picker--hide');
  }

  showDatePicker() {
    this.ahoy.sendEvent();
    let datePickerElement = this.element.querySelector('.b-livestreaming-daily-schedule__date-picker');
    datePickerElement.classList.remove('b-livestreaming-daily-schedule__date-picker--hide');
    this.changeDateIconToUp();
  }

  changeDateIconToUp(){
    let dateIcon = this.element.querySelector('.b-livestreaming-daily-schedule__date-icon');
    if (dateIcon) {
      dateIcon.classList.add('b-livestreaming-daily-schedule__date-icon--up');
    }
  }

  hideDatePicker() {
    let datePickerElement = this.element.querySelector('.b-livestreaming-daily-schedule__date-picker');
    datePickerElement.classList.add('b-livestreaming-daily-schedule__date-picker--hide');
    this.changeDateIconToDown();
  }

  changeDateIconToDown(){
    let dateIcon = this.element.querySelector('.b-livestreaming-daily-schedule__date-icon');
    if (dateIcon) {
      dateIcon.classList.remove('b-livestreaming-daily-schedule__date-icon--up');
    }
  }
}
